import { useDispatch, useSelector } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import { useContext, useEffect, useState } from "react";
import { SelectButton } from "primereact/selectbutton";
import { addDays, subDays, format, set, addMonths } from "date-fns";
import EventCalendar from "../../../../components/components/event-calendar/EventCalendar";
import { Sidebar } from "primereact/sidebar";
import ListAppointment from "./ListAppointment";
import { Button } from "primereact/button";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";
import { ConfirmDialog } from "primereact/confirmdialog";
import { animate } from "framer-motion";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";

const title = "Appointment - Mobile";

// const thisMonthFirstDay = set(new Date(), { date: 1 });

const AppointmentMobilePage = (props) => {
  const uiContext = useContext(UiContext);

  const dispatch = useDispatch();
  const [events, setEvents] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const { loading, requestGet } =
    useAPIRequest();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    handleChangeDate(selectedMonth);
  }, []);

  const convertScheduleCustomerToAppointment = (list) => {
    return list.map((item) => {
      return {
        date: new Date(item.transaction_date),
        title: item.data_customer
          ? item.data_customer.name
          : "*Not Registered*",
        data: item,
        animate: !item.confirmation_bc_date ? true : false,
        stale: !item.confirmation_bc_date ? true : false,
      };
    });
  };

  // const loadAppointment = async (id) => {
  //   return await requestGetOne({
  //     fullUrl: `api/crm/crmschedulecustomer/one/${id}`,
  //     onSuccess: ({ data }) => {
  //       setEditingAppointment(data);
  //     },
  //     onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
  //   });
  // };

  const handleChangeDate = async (date) => {
    setEvents([]);

    // console.log("DATE ", date);
    // setSelectedMonth(date);

    const dateTxt = format(date, "yyyy-MM-dd");

    let fromDate = dateTxt + " 00:00:00";
    let toDate = dateTxt + " 23:59:59";

    return await requestGet({
      fullUrl: "api/masterdata/employee/get-schedule",
      params: {
        take: 10000,
        page: 1,
        order: "transaction_date",
        order_method: "ASC",
        filter: `transaction_date:>=:${fromDate};transaction_date:<=:${toDate}`,
        with_customer: 1,
        with_bc: 1,
        with_therapist_1: 1,
        with_therapist_2: 1,
        with_therapist_3: 1,
        with_nurse_1: 1,
        with_nurse_2: 1,
        with_nurse_3: 1,
        with_doctor: 1,
        with_products: 1,
        with_crm_options: 1,
      },
      onSuccess: ({ data }) => {
        const newData = convertScheduleCustomerToAppointment(data);
        setEvents(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const getEventsByDate = (date) => {
    return events.filter(
      (event) => format(event.date, "yyyy-MM-dd") === format(date, "yyyy-MM-dd")
    );
  };

  return (
    <div className={`col-start-start px-4 gap-4 w-100`}>
      <ConfirmDialog />
      <div></div>

      <div className="elevated-card-tight-vertical !px-4 w-100">
        <Calendar
          className="w-full "
          value={selectedDate}
          onChange={(e) => {
            setSelectedDate(e.value);
            handleChangeDate(e.value);
          }}
          inline
          locale="id"
          pt={{
            day: {
              className: "text-sm",
            },
            weekDay: {
              className: "text-sm",
            },
          }}
        />
      </div>

      <div className="elevated-card-tight-vertical row-between-center !py-2 !px-4 w-100">
        <span className="text-sm font-semibold text-slate-600">
          {selectedDate.toLocaleDateString("en-EN", {
            year: "numeric",
            month: "short",
            day: "numeric",
            weekday: "long",
          })}
        </span>
        <div className="row-start-center gap-2">
          {loading && (
            <ProgressSpinner
              className="h-[1.5rem] w-[1.5rem]"
              strokeWidth="4"
            />
          )}
          <div className="row-start-center gap-1 bg-indigo-500 px-4 py-1 rounded-full">
            <span className="text-sm font-semibold text-white">
              {events.length}
            </span>
          </div>
        </div>
      </div>

      <div className="elevated-card-tight-vertical col-start-start !px-4 w-100">
        <ListAppointment
          events={getEventsByDate(selectedDate)}
        />
      </div>

      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default AppointmentMobilePage;
